<script setup lang="ts">
</script>
<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <h2 class="text-xl text-center mt-4">
                    Our site is currently down for maintenance
                </h2>
                <p>
                    We apologise for any inconvenience, please try again later.
                </p>
            </div>
        </div>
    </div>
</template>
<style>
    .logo {
    background-size: contain;
    margin-top: 11px;
    background-repeat: no-repeat;
    min-width: 183px;
    min-height: 28px;
    max-width: 300px;
    margin-bottom: 11px;
    font-family: 'Poppins', sans-serif;
    }
</style>
